import { takeLatest, all, takeEvery } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../_config";

import {
  forgotPassword,
  getUserProfile,
  loginUser,
  logoutUser,
  updateUserProfile,
  companyUploadLogo,
  deleteUser,
  AutoLogin,
  loginWithEmail,
  resetPassword,
  registration,
  completeProfile,
  updateDisplayName,
  checkValidToken,
  getRegistrationFieldsData,
  saveNotification,
  verifyEmail,
  resendVerification,
  updateTwoFactorAuth,
  verify2FA,
  getUserPermissionsModule,
  addCompanyBillingInfo,
  getCompanyBillingInfo,
  getMyActivity,
  getAllUsersActivity,
  deleteAccount,
  getUserData,
  getNotifications,
} from "./userSaga";

import {
  getCities,
  getStatesNew,
  getCountries,
  getGameDetails,
  getStates,
  contactUs,
  contactSupport,
  getSEOList,
  getLanguages,
  getWorkPlaces,
  getJobPostTypes,
  getSkills,
  getIndustries,
  getCountriesNew,
  getCitiesNew,
  getCurrencies,
  getSalaryRanges,
  getFunctionalAreas,
  getDesignations,
  getEducationLevels,
  getJobTitleSuggestions,
  enhanceText,
  generateJobDescriptionSkills,
  getNationalities,
  sendOfferLetterFile,
  sendOfferLetter,
  generateOfferLetter,
  updateCounterOfferStatus,
  getPendingActions,
} from "./commonSaga";

import { getCmsContent, getPageBySlug } from "./cmsSaga";

import {
  getEmployerJobs,
  getJobDetails,
  updateJobStatus,
  cloneJob,
  getJobCandidates,
  getCandidateDetails,
  getScreening,
  bulkResumeUpload,
  getJobStatusCounts,
  getAppliedJobsLastSevenDays,
  getJobAllStatusCounts,
  getJobseekerDetailsById,
  triggerMatching,
  userJobRefreshSet,
  userJobRefreshRemove,
  userJobRefreshGet,
  deleteJob,
} from "./jobSaga";
import { createJob, updateJob } from "./jobPostingSaga";

// Import new saga functions
import { getPermissions, getPermissionsMatrix, getPermissionsModuleJobs } from "./permissionsSaga";

import {
  createUser,
  uploadProfilePhoto,
  getUsers,
  updateUser,
  getUser,
  deleteUser as deleteUserManagement,
  resendWelcomeEmail,
  updateRolePermissions,
  getUserPermissions,
  inviteUser,
} from "./usersManagementSaga";

import { getRoles, getRolePermissions } from "./rolesSaga";

import {
  addAvailability,
  addUnavailability,
  deleteUnavailability,
  getSchedule,
  getAvailableTimeSlots,
  scheduleRequest,
  scheduleRequestAI,
  getVideoCallData,
  rescheduleOrCancel,
  updateValidity,
  submitInterviewFeedback,
  getInterviewEvaluation,
} from "./interviewSaga";

import { startRecording, stopRecording, queryRecording, instantCall } from "./agoraRecordingSaga";

import { addScreeningFeedback, getScreeningHistory, updateScreeningStatus } from "./screeningSaga";

import {
  getSubscriptionPlans,
  createPayment,
  paymentSuccess,
  paymentCancel,
  getInvoices,
  cancelSubscription,
} from "./subscriptionSaga";

import { getJobseekersWithVideo } from "./videoCVSaga";

import { getJobseekers, getJobseekersAdvanced } from "./candidatesSaga";

import { addExperienceRating, getExperienceRating, updateExperienceRating } from "./experienceRatingSaga";

export function* sagas() {
  yield all([
    // user saga
    takeLatest(SAGA_ACTIONS.USER.DETAILS, getUserProfile),
    takeLatest(SAGA_ACTIONS.USER.LOGIN, loginWithEmail),
    takeLatest(SAGA_ACTIONS.USER.AUTO_LOGIN, AutoLogin),
    takeLatest(SAGA_ACTIONS.USER.FORGOT_PASSWORD, forgotPassword),
    takeLatest(SAGA_ACTIONS.USER.RESET_PASSWORD, resetPassword),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION, registration),
    takeLatest(SAGA_ACTIONS.USER.COMPLETE_PROFILE, completeProfile),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_PROFILE, updateUserProfile),
    takeLatest(SAGA_ACTIONS.USER.COMPANY_UPLOAD_LOGO, companyUploadLogo),
    takeLatest(SAGA_ACTIONS.USER.LOGOUT, logoutUser),
    takeLatest(SAGA_ACTIONS.USER.DELETE_USER, deleteUser),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, updateDisplayName),
    takeLatest(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, checkValidToken),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, getRegistrationFieldsData),
    takeLatest(SAGA_ACTIONS.USER.SAVE_NOTIFICATION, saveNotification),
    takeLatest(SAGA_ACTIONS.USER.VERIFY_EMAIL, verifyEmail),
    takeLatest(SAGA_ACTIONS.USER.RESEND_VERIFICATION, resendVerification),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_TWO_FACTOR_AUTH, updateTwoFactorAuth),
    takeLatest(SAGA_ACTIONS.USER.VERIFY_2FA, verify2FA),
    takeLatest(SAGA_ACTIONS.USER.GET_PERMISSIONS, getUserPermissionsModule),
    takeLatest(SAGA_ACTIONS.USER.ADD_COMPANY_BILLING_INFO, addCompanyBillingInfo),
    takeLatest(SAGA_ACTIONS.USER.GET_COMPANY_BILLING_INFO, getCompanyBillingInfo),
    takeLatest(SAGA_ACTIONS.USER.MY_ACTIVITY, getMyActivity),
    takeLatest(SAGA_ACTIONS.USER.ALL_USERS_ACTIVITY, getAllUsersActivity),
    takeLatest(SAGA_ACTIONS.USER.DELETE_ACCOUNT, deleteAccount),
    takeLatest(SAGA_ACTIONS.USER.USER_DATA, getUserData),
    takeLatest(SAGA_ACTIONS.USER.NOTIFICATIONS, getNotifications),

    //COMMON Saga
    takeLatest(SAGA_ACTIONS.COMMON.GAME_DETAILS, getGameDetails),
    takeLatest(SAGA_ACTIONS.COMMON.COUNTRIES, getCountries),
    takeLatest(SAGA_ACTIONS.COMMON.STATES, getStates),
    takeLatest(SAGA_ACTIONS.COMMON.CITIES, getCities),
    takeLatest(SAGA_ACTIONS.COMMON.CONTACTUS, contactUs),
    takeLatest(SAGA_ACTIONS.COMMON.CONTACT_SUPPORT, contactSupport),
    takeLatest(SAGA_ACTIONS.COMMON.SEO_LIST, getSEOList),
    takeLatest(SAGA_ACTIONS.COMMON.LANGUAGES, getLanguages),
    takeLatest(SAGA_ACTIONS.COMMON.WORK_PLACES, getWorkPlaces),
    takeLatest(SAGA_ACTIONS.COMMON.JOB_POST_TYPES, getJobPostTypes),
    takeLatest(SAGA_ACTIONS.COMMON.SKILLS, getSkills),
    takeLatest(SAGA_ACTIONS.COMMON.INDUSTRIES, getIndustries),
    takeLatest(SAGA_ACTIONS.COMMON.COUNTRIES_NEW, getCountriesNew),
    takeLatest(SAGA_ACTIONS.COMMON.STATES_NEW, getStatesNew),
    takeLatest(SAGA_ACTIONS.COMMON.CITIES_NEW, getCitiesNew),
    takeLatest(SAGA_ACTIONS.COMMON.CURRENCIES, getCurrencies),
    takeLatest(SAGA_ACTIONS.COMMON.SALARY_RANGES, getSalaryRanges),
    takeLatest(SAGA_ACTIONS.COMMON.FUNCTIONAL_AREAS, getFunctionalAreas),
    takeLatest(SAGA_ACTIONS.COMMON.DESIGNATIONS, getDesignations),
    takeLatest(SAGA_ACTIONS.COMMON.EDUCATION_LEVELS, getEducationLevels),
    takeLatest(SAGA_ACTIONS.COMMON.JOB_TITLE_SUGGESTIONS, getJobTitleSuggestions),
    takeLatest(SAGA_ACTIONS.COMMON.ENHANCE_TEXT, enhanceText),
    takeLatest(SAGA_ACTIONS.COMMON.NATIONALITIES, getNationalities),
    takeLatest(SAGA_ACTIONS.COMMON.GENERATE_JOB_DESCRIPTION_SKILLS, generateJobDescriptionSkills),

    //CMS Saga
    takeLatest(SAGA_ACTIONS.CMS.GET_CMS, getCmsContent),
    takeLatest(SAGA_ACTIONS.CMS.GET_PAGE_BY_SLUG, getPageBySlug),
    // Job Posting Saga
    takeLatest(SAGA_ACTIONS.JOB_POSTING.CREATE_JOB, createJob),
    takeLatest(SAGA_ACTIONS.JOB_POSTING.UPDATE_JOB, updateJob),

    //JOB Saga
    takeEvery(SAGA_ACTIONS.JOB.GET_EMPLOYER_JOBS, getEmployerJobs),
    takeLatest(SAGA_ACTIONS.JOB.GET_JOB_DETAILS, getJobDetails),
    takeLatest(SAGA_ACTIONS.JOB.UPDATE_JOB_STATUS, updateJobStatus),
    takeLatest(SAGA_ACTIONS.JOB.CLONE_JOB, cloneJob),
    takeLatest(SAGA_ACTIONS.JOB.GET_JOB_CANDIDATES, getJobCandidates),
    takeLatest(SAGA_ACTIONS.JOB.GET_CANDIDATE_DETAILS, getCandidateDetails),
    takeLatest(SAGA_ACTIONS.JOB.GET_SCREENING, getScreening),
    takeLatest(SAGA_ACTIONS.JOB.BULK_RESUME_UPLOAD, bulkResumeUpload),
    takeLatest(SAGA_ACTIONS.JOB.GET_JOB_STATUS_COUNTS, getJobStatusCounts),
    takeLatest(SAGA_ACTIONS.JOB.GET_APPLIED_JOBS_LAST_SEVEN_DAYS, getAppliedJobsLastSevenDays),
    takeLatest(SAGA_ACTIONS.JOB.GET_JOB_ALL_STATUS_COUNTS, getJobAllStatusCounts),
    takeLatest(SAGA_ACTIONS.JOB.GET_JOBSEEKER_DETAILS_BY_ID, getJobseekerDetailsById),
    takeLatest(SAGA_ACTIONS.JOB.TRIGGER_MATCHING, triggerMatching),
    takeLatest(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_SET, userJobRefreshSet),
    takeLatest(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_REMOVE, userJobRefreshRemove),
    takeLatest(SAGA_ACTIONS.JOB.USER_JOB_REFRESH_GET, userJobRefreshGet),
    takeLatest(SAGA_ACTIONS.JOB.DELETE_JOB, deleteJob),

    //PERMISSIONS Saga
    takeLatest(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS, getPermissions),
    takeLatest(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS_MATRIX, getPermissionsMatrix),
    takeLatest(SAGA_ACTIONS.PERMISSIONS.GET_PERMISSIONS_MODULE_JOBS, getPermissionsModuleJobs),

    //USERS MANAGEMENT Saga
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.CREATE_USER, createUser),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.UPLOAD_PROFILE_PHOTO, uploadProfilePhoto),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USERS, getUsers),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.UPDATE_USER, updateUser),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USER, getUser),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.DELETE_USER, deleteUserManagement),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.RESEND_WELCOME_EMAIL, resendWelcomeEmail),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.UPDATE_ROLE_PERMISSIONS, updateRolePermissions),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.GET_USER_PERMISSIONS, getUserPermissions),
    takeLatest(SAGA_ACTIONS.USERS_MANAGEMENT.INVITE_USER, inviteUser),

    //ROLES Saga
    takeLatest(SAGA_ACTIONS.ROLES.GET_ROLES, getRoles),
    takeLatest(SAGA_ACTIONS.ROLES.GET_ROLE_PERMISSIONS, getRolePermissions),

    // INTERVIEW Saga
    takeLatest(SAGA_ACTIONS.INTERVIEW.ADD_AVAILABILITY, addAvailability),
    takeLatest(SAGA_ACTIONS.INTERVIEW.ADD_UNAVAILABILITY, addUnavailability),
    takeLatest(SAGA_ACTIONS.INTERVIEW.DELETE_UNAVAILABILITY, deleteUnavailability),
    takeLatest(SAGA_ACTIONS.INTERVIEW.GET_SCHEDULE, getSchedule),
    takeLatest(SAGA_ACTIONS.INTERVIEW.GET_AVAILABLE_TIME_SLOTS, getAvailableTimeSlots),
    takeLatest(SAGA_ACTIONS.INTERVIEW.SCHEDULE_REQUEST, scheduleRequest),
    takeLatest(SAGA_ACTIONS.INTERVIEW.SCHEDULE_REQUEST_AI, scheduleRequestAI),
    takeLatest(SAGA_ACTIONS.INTERVIEW.GET_VIDEO_CALL_DATA, getVideoCallData),
    takeLatest(SAGA_ACTIONS.INTERVIEW.RESCHEDULE_OR_CANCEL, rescheduleOrCancel),
    takeLatest(SAGA_ACTIONS.INTERVIEW.UPDATE_VALIDITY, updateValidity),
    takeLatest(SAGA_ACTIONS.INTERVIEW.SUBMIT_FEEDBACK, submitInterviewFeedback),
    takeLatest(SAGA_ACTIONS.INTERVIEW.GET_EVALUATION, getInterviewEvaluation),

    // AGORA RECORDING Saga
    takeLatest(SAGA_ACTIONS.AGORA_RECORDING.START, startRecording),
    takeLatest(SAGA_ACTIONS.AGORA_RECORDING.STOP, stopRecording),
    takeLatest(SAGA_ACTIONS.AGORA_RECORDING.QUERY, queryRecording),

    // AGORA Saga
    takeLatest(SAGA_ACTIONS.AGORA.INSTANT_CALL, instantCall),

    // SCREENING Saga
    takeLatest(SAGA_ACTIONS.SCREENING.ADD_FEEDBACK, addScreeningFeedback),
    takeLatest(SAGA_ACTIONS.SCREENING.GET_HISTORY, getScreeningHistory),
    takeLatest(SAGA_ACTIONS.SCREENING.UPDATE_STATUS, updateScreeningStatus),

    // SUBSCRIPTION Saga
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.GET_SUBSCRIPTION_PLANS, getSubscriptionPlans),
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.GET_INVOICES, getInvoices),
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.CREATE_PAYMENT, createPayment),
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.PAYMENT_SUCCESS, paymentSuccess),
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.PAYMENT_CANCEL, paymentCancel),
    takeLatest(SAGA_ACTIONS.SUBSCRIPTION.CANCEL_SUBSCRIPTION, cancelSubscription),
    // OFFER LETTER Saga
    takeLatest(SAGA_ACTIONS.OFFER_LETTER.SEND_FILE, sendOfferLetterFile),
    takeLatest(SAGA_ACTIONS.OFFER_LETTER.SEND, sendOfferLetter),
    takeLatest(SAGA_ACTIONS.OFFER_LETTER.GENERATE, generateOfferLetter),
    takeLatest(SAGA_ACTIONS.OFFER_LETTER.UPDATE_COUNTER_OFFER_STATUS, updateCounterOfferStatus),
    takeLatest(SAGA_ACTIONS.OFFER_LETTER.PENDING_ACTIONS, getPendingActions),

    takeLatest(SAGA_ACTIONS.JOB.GET_JOB_CANDIDATES, getJobCandidates),

    // VIDEO CV Saga
    takeLatest(SAGA_ACTIONS.VIDEO_CV.GET_JOBSEEKERS_WITH_VIDEO, getJobseekersWithVideo),

    // CANDIDATES Saga
    takeLatest(SAGA_ACTIONS.CANDIDATES.GET_JOBSEEKERS, getJobseekers),
    takeLatest(SAGA_ACTIONS.CANDIDATES.GET_JOBSEEKERS_ADVANCED, getJobseekersAdvanced),

    // EXPERIENCE RATING Saga
    takeLatest(SAGA_ACTIONS.EXPERIENCE_RATING.ADD, addExperienceRating),
    takeLatest(SAGA_ACTIONS.EXPERIENCE_RATING.GET, getExperienceRating),
    takeLatest(SAGA_ACTIONS.EXPERIENCE_RATING.UPDATE, updateExperienceRating),
  ]);
}
